import moment from 'moment';

export default {
  name: 'datePicker',
  data () {
    return {
      yearsModel: null,
      years: [],
      monthsModel: null,
      months: [],
      daysModel: null,
      days: []
    };
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    valueFormat: {
      type: String,
      default: 'YYYY-MM-DD'
    }
  },
  created() {
    this.init();
    this.value && this.showDate();
  },
  watch: {
    'value': function(val) {
      val && this.showDate();
    }
  },
  methods: {
    // 日期回显
    showDate() {
      let currDate = moment(new Date(this.value));
      this.yearsModel = Number(currDate.format('YYYY'));
      this.monthsModel = Number(currDate.format('MM'));
      this.daysModel = Number(currDate.format('DD'));
      let obj = { year: this.yearsModel, month: this.monthsModel, day: this.daysModel };
      this.getFormatDate(obj);
    },
    init(){
      // 时间控件范围：2000年1月1日到2099年12月31日

      var myDate = new Date('2000-01-01');
      var year = myDate.getFullYear(); // 获取当前年
      var month = myDate.getMonth() + 1; // 获取当前月

      this.initSelectYear(year);
      this.initSelectMonth();
      this.initSelectDay(year, month);

      this.yearsModel = null;
      this.monthsModel = null;
      this.daysModel = null;

      let obj = { year: this.yearsModel, month: this.monthsModel, day: this.daysModel };
      this.getFormatDate(obj);
    },
    initSelectYear(year){
      this.years = [];
      for(let i = 0; i < 100; i++){
        this.years.push({value: (year + i), label: (year + i)+ '年'});
      }
    },
    initSelectMonth(){
      this.months = [];
      for(let i = 1; i <= 12; i++){
        this.months.push({value: i, label: i+ '月'});
      }
    },
    initSelectDay(year, month){
      var maxDay = this.getMaxDay(year, month);
      this.days = [];
      for(var i = 1; i <= maxDay; i++){
        this.days.push({value: i, label: i+ '日'});
      }
    },
    dateChange(type){
    // 1年 2月 3日 4 左 5右
      if(type === 1 || type === 2){
        if(this.monthsModel === 0){
          this.daysModel = 0;
          this.initSelectDay(this.yearsModel, 1);
        }else{
          this.initSelectDay(this.yearsModel, this.monthsModel);
        }
      }
      // 操作父组件方法
      let obj = {
        year: this.yearsModel,
        month: this.monthsModel,
        day: this.daysModel
      };
      obj.month = (Number(obj.month) < 10) ? obj.month = `0${obj.month || 0}` : obj.month;
      obj.day = (Number(obj.day) < 10) ? obj.day = `0${obj.day || 0}` : obj.day;
      this.getFormatDate(obj);
    },
    getMaxDay(year, month){
      var new_year = year;  // 取当前的年份
      var new_month = month++;// 取下一个月的第一天，方便计算（最后一天不固定）
      if(month>12) {      // 如果当前大于12月，则年份转到下一年
        new_month -=12;    // 月份减
        new_year++;      // 年份增
      }
      var new_date = new Date(new_year, new_month, 1);// 取当年当月中的第一天
      return (new Date(new_date.getTime()-1000*60*60*24)).getDate();// 获取当月最后一天日期
    },
    // 根据传入的格式返回时间
    getFormatDate(dateObj) {
      let flag = false;
      // 年
      if(this.valueFormat === 'YYYY') {
        flag = dateObj.year;
      }
      // 月日
      if(this.valueFormat === 'MM-DD'){
        flag = dateObj.month > 0 && dateObj.day > 0;
      }
      // 年月日
      if(this.valueFormat === 'YYYY-MM-DD'){
        flag = dateObj.year && dateObj.month > 0 && dateObj.day > 0;
      }

      if(flag) {
        let time = `${dateObj.year}-${dateObj.month}-${dateObj.day}`;
        let showTime = this.valueFormat === 'YYYY' ? String(dateObj.year) : moment(time).format(this.valueFormat);

        this.$emit('update:value', showTime);
      } else {
        this.$emit('update:value', '');
      }
    }
  }
};
